export default __webpack_public_path__ + "static/media/2cd43b_1253868455ff42ef97513b70d65a3f21_mv2.cae6eaca.png";